export interface FontWeight {
  regular: number
  semiBold: number
}

export const fontWeight: FontWeight = {
  regular: 400,
  semiBold: 600,
}
